exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.basic-attribute .operatebtn[data-v-6e0fa8b0]{width:100%;text-align:center;margin-top:40px\n}\n.basic-attribute .el-button[data-v-6e0fa8b0]:nth-child(1){background-color:#697783;border-color:#697783\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/components/basic/goodsmanage/basic-attribute.vue"],"names":[],"mappings":";AAsBA,8CAEI,WACA,kBACA,eAAgB;CAJpB;AAAA,0DAOI,yBACA,oBAAoB;CACrB","file":"basic-attribute.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.basic-attribute {\n  .operatebtn {\n    width: 100%;\n    text-align: center;\n    margin-top: 40px;\n  }\n  .el-button:nth-child(1) {\n    background-color: #697783;\n    border-color:#697783;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e0fa8b0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/basic/goodsmanage/basic-attribute.vue
// module id = SzGR
// module chunks = 2